import { motion } from "framer-motion";

const STROKE = "#131417";

export default function YmfLogo({ size = 56, className = "", withWink = true, stroke = STROKE }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={className}
      role="img"
      aria-label="Logo de Ye muy fácil: un libro azul con una carita amarilla que guiña un ojo"
    >
      <g transform="rotate(-3 60 64)">
        {/* páginas superiores */}
        <path d="M31 20 L97 12 L98 18 L32 26 Z" fill="#fff" stroke={stroke} strokeWidth="2.5" strokeLinejoin="round" />
        <path d="M31 25 L97 17 L98 23 L32 31 Z" fill="#fff" stroke={stroke} strokeWidth="2.5" strokeLinejoin="round" />
        {/* lomo */}
        <path d="M29 27 C21 29 21 91 29 93 L37 95 L37 29 Z" fill="var(--blue)" stroke={stroke} strokeWidth="2.5" strokeLinejoin="round" />
        <path d="M29 42 C26 43 26 48 29 49" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
        <path d="M29 56 C26 57 26 62 29 63" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
        {/* portada */}
        <rect x="35" y="23" width="64" height="74" rx="5" fill="var(--blue)" stroke={stroke} strokeWidth="2.5" />
        {/* carita */}
        <circle cx="67" cy="60" r="21" fill="var(--yellow)" stroke={stroke} strokeWidth="2.5" />
        {/* ojo izquierdo abierto */}
        <ellipse cx="60" cy="56" rx="3" ry="4.5" fill={stroke} />
        {withWink ? (
          <>
            <motion.path
              d="M70 52 L80 56 L70 60"
              stroke={stroke}
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              initial={false}
              animate={{ opacity: [1, 1, 0, 0, 1, 1] }}
              transition={{ duration: 0.9, times: [0, 0.7, 0.78, 0.86, 0.94, 1], repeat: Infinity, repeatDelay: 2.8 }}
            />
            <motion.circle
              cx="75"
              cy="56"
              r="4.2"
              fill={stroke}
              initial={false}
              animate={{ opacity: [0, 0, 1, 1, 0, 0] }}
              transition={{ duration: 0.9, times: [0, 0.7, 0.78, 0.86, 0.94, 1], repeat: Infinity, repeatDelay: 2.8 }}
            />
          </>
        ) : (
          <circle cx="75" cy="56" r="4.2" fill={stroke} />
        )}
        {/* sonrisa */}
        <path d="M57 65 C62 71 73 71 78 64" stroke={stroke} strokeWidth="3" strokeLinecap="round" fill="none" />
      </g>
    </svg>
  );
}

export function WinkFace({ size = 44, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
      <circle cx="32" cy="32" r="27" fill="var(--yellow)" stroke="#131417" strokeWidth="3" />
      <ellipse cx="23" cy="27" rx="3" ry="4.5" fill="#131417" />
      <path d="M36 25 L47 29 L36 33" stroke="#131417" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 40 C26 47 39 47 45 39" stroke="#131417" strokeWidth="3.4" fill="none" strokeLinecap="round" />
    </svg>
  );
}
